import React, { cloneElement } from 'react';
import { usePropState, useEvent } from '@anton.bobrov/react-hooks';
import { BasePopup as BasePopup$1 } from '@anton.bobrov/react-components';
import cx from 'classnames';
import styles from './index.module.scss.js';

const BasePopup = ({
  className,
  style,
  anchor,
  children,
  kind = "primary",
  spacing = "medium",
  onActive,
  isActive: isActiveProp,
  showEvent = "click",
  ...props
}) => {
  const [isActive, setIsActive] = usePropState(isActiveProp);
  const handleActive = useEvent((is) => {
    onActive?.(is);
    setIsActive(is);
  });
  return /* @__PURE__ */ React.createElement(
    BasePopup$1,
    {
      ...props,
      className: cx(styles.box, className, {
        [styles[kind]]: !!kind,
        [styles[spacing]]: !!spacing
      }),
      style,
      anchor: cloneElement(anchor, { ...anchor.props, isActive }),
      showEvent,
      onActive: handleActive,
      isActive
    },
    children
  );
};
BasePopup.displayName = "Popup.BasePopup";

export { BasePopup };
//# sourceMappingURL=index.js.map
